import AdditionIcon from '../../assets/teacher/addition.svg'
import SubtractionIcon from '../../assets/teacher/subtract.svg'
import MultiplicationIcon from '../../assets/teacher/multiply.svg'
import DivisionIcon from '../../assets/teacher/divide.svg'

export const DIFFICULTIES: Record<number, string> = {
  0: 'Beginning',
  1: 'Regular',
  2: 'Expanded',
}

export const THRESHOLDS: Record<number, string> = {
  0: '12 seconds',
  64: '6 seconds',
  128: '3 seconds',
  192: '2 seconds',
  256: '1.5 seconds',
}

export const OPERATION_ICONS = {
  addition: AdditionIcon,
  subtraction: SubtractionIcon,
  multiplication: MultiplicationIcon,
  division: DivisionIcon,
} as const

type OperationKey = keyof typeof OPERATION_ICONS

const OPERATION_MIXES: Record<number, OperationKey[]> = {
  4: ['addition'],
  8: ['subtraction'],
  12: ['addition', 'subtraction'],
  16: ['multiplication'],
  20: ['addition', 'multiplication'],
  24: ['subtraction', 'multiplication'],
  28: ['addition', 'subtraction', 'multiplication'],
  32: ['division'],
  36: ['addition', 'division'],
  40: ['division', 'subtraction'],
  44: ['addition', 'subtraction', 'division'],
  48: ['multiplication', 'division'],
  52: ['addition', 'multiplication', 'division'],
  56: ['subtraction', 'multiplication', 'division'],
  60: ['addition', 'subtraction', 'multiplication', 'division'],
}

const formatOperationName = (key: OperationKey): string => {
  return key.charAt(0).toUpperCase() + key.slice(1)
}

const formatOperationMix = (operations: OperationKey[]): string => {
  if (operations.length === 1) {
    return formatOperationName(operations[0])
  }
  if (operations.length === 2) {
    return `${formatOperationName(operations[0])} and ${formatOperationName(
      operations[1]
    )}`
  }
  const formatted = operations.map(formatOperationName)
  const last = formatted.pop()
  return `${formatted.join(', ')} and ${last}`
}

export const PROGRAM_ICONS: Record<number, OperationKey[]> = OPERATION_MIXES

export const MATH_OPERATION_MIXES: Record<number, string> = Object.entries(
  OPERATION_MIXES
).reduce(
  (acc, [id, operations]) => {
    acc[Number(id)] = formatOperationMix(operations)
    return acc
  },
  {} as Record<number, string>
)
